define( function() {
	return ( /\S+/g );
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/var/rnotwhite.js
 ** module id = 454
 ** module chunks = 2
 **/